// Central SEO helpers and per-route metadata.
// Production canonical host — used both for canonical <link> and for
// building the absolute og:url and og:image URLs. This is intentional:
// we want search engines and social crawlers to point at the production
// domain even when a user is browsing on the preview subdomain.
export const SITE_URL = "https://schengenfile.com";
export const SITE_NAME = "SchengenFile";
export const OG_IMAGE = `${SITE_URL}/og-image.png`;
export const OG_IMAGE_WIDTH = 1200;
export const OG_IMAGE_HEIGHT = 630;

/**
 * Absolute URL for a given path on the canonical domain.
 * Always drops query strings and hashes — SEO canonical rules.
 */
export function canonicalUrl(pathname = "/") {
  const clean = (pathname || "/").split("?")[0].split("#")[0];
  return `${SITE_URL}${clean === "/" ? "" : clean}`;
}
